<template>
  <a :class="[$style.root, 'btn', 'btn-link', 'link-body']"><slot></slot></a>
</template>

<style lang="scss" module>
.root {
  /* Not empty */
}
</style>
